// A tiny in-memory event log for Read Aloud, surfaced in an on-page console so
// narration behaviour can be inspected and copied without the devtools.

export interface TtsLogEntry {
  t: number;
  event: string;
  data?: Record<string, unknown>;
}

const MAX = 600;
let entries: TtsLogEntry[] = [];
const listeners = new Set<() => void>();

export function ttsLog(event: string, data?: Record<string, unknown>): void {
  entries = [...entries, { t: Date.now(), event, data }].slice(-MAX);
  for (const l of listeners) l();
}

export function getTtsLog(): TtsLogEntry[] {
  return entries;
}

export function clearTtsLog(): void {
  entries = [];
  for (const l of listeners) l();
}

export function subscribeTtsLog(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Flatten the log to copy-pasteable text. */
export function formatTtsLog(): string {
  if (entries.length === 0) return "";
  const t0 = entries[0]!.t;
  return entries
    .map((e) => {
      const ms = String(e.t - t0).padStart(6, " ");
      const data = e.data ? " " + JSON.stringify(e.data) : "";
      return `+${ms}ms  ${e.event}${data}`;
    })
    .join("\n");
}
